import React, { useState, useEffect } from 'react';
import useGlobal from '../../store';
import AvatarUploader from '../General/AvatarUploader';
import CurrencySymbol from '../General/CurrencySymbol';

const UserProfile = (props) => {

    const [connectionData, setConnectionData] = useState(null);
    
    const [user] = useGlobal(
        state => state.user
    );
    const [giftlists] = useGlobal(
        state => state.giftlists
    );
    const [activeGiftlist] = useGlobal(
        state => state.activeGiftlist
    );
    const [ui, uiActions] = useGlobal(
        state => state.ui.giftlist,
        actions => actions.uiActions
    );

    const buildAvatarImage = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && userData.avatarFile.indexOf('_avatar') > 0) {
	        return <img src={"https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2"} alt="" />;
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return <img src={"https://graph.facebook.com/" + userData.FBID + "/picture?type=large"} alt="" />;
        }
        return (<div className="kt-media kt-media--xl kt-media--circle kt-media--info">
            <span>{userData.FirstName ? userData.FirstName.charAt(0) : '?'}{userData.LastName ? userData.LastName.charAt(0) : ''}</span>
        </div>);
    }

    const buildAvatarUrl = (userData) => {
        if(userData.hasOwnProperty('avatarFile') && userData.avatarFile && (userData.avatarFile.indexOf('_avatar') > 0 || userData.avatarFile.length > 30)) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile + "?w=100&h=100&fit=facearea&faceindex=1&facepad=2";
	    }
	    if(userData.FBID && userData.FBID !== "0") {
	        return "https://graph.facebook.com/" + userData.FBID + "/picture?type=large";
	    }
	    if(userData.hasOwnProperty('avatarFile') && userData.avatarFile) {
	        return "https://weblight.imgix.net/avatars/"+userData.avatarFile;
	    }
	    return "";
    }

    const tabClick = (tabname,e) => {
        e.preventDefault();
        uiActions.setGiftlistActiveTab(tabname);
    }

    useEffect(() => {
        if(!user || !activeGiftlist) {
            return;
        }
        let conn = giftlists.filter(gl => gl.userID === activeGiftlist.user.userID);
        if(conn.length > 0) {
            console.log('SETTING CONNECTION DATA', conn[0]);
            setConnectionData(conn[0]);
        }
    }, [user, giftlists, activeGiftlist]);


    return (activeGiftlist.user && user ?
        <div className="kt-portlet kt-profile">
            <div className="kt-profile__content">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-xl-4">
                        <div className="kt-profile__main">
                            <div className="kt-profile__main-pic">
                                {connectionData && user
                                && connectionData.addedBy 
                                && connectionData.addedBy !== "0"
                                && connectionData.isUser !== "1"
                                && connectionData.addedBy.userID === user.userID ?
                                    <AvatarUploader {...activeGiftlist.user} avatar={buildAvatarUrl(activeGiftlist.user)}></AvatarUploader>
                                : buildAvatarImage(activeGiftlist.user)}
                            </div>
                            <div className="kt-profile__main-info">
                                <div className="kt-profile__main-info-name">{activeGiftlist.user.FirstName} {activeGiftlist.user.LastName}</div>
                                {connectionData 
                                && connectionData.addedBy 
                                && connectionData.addedBy !== "0"
                                && connectionData.isUser !== "1" ?
                                <div className="kt-profile__main-info-position">
                                    Managed by {connectionData.addedBy.FirstName} {connectionData.addedBy.LastName}
                                </div> : <></> }
                                
                            </div>

                            {activeGiftlist.user.about ? <div className="mt-3 kt-profile__main-info-position">{activeGiftlist.user.about}</div> : <></> }
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-xl-4">
                        <div className="kt-profile__stats">
                            
                            <div className="kt-widget kt-widget--general-3 p-0">
                            <div className="kt-widget__top p-0">
                            <div className="kt-widget__wrapper">
                            <div className="kt-widget__stats">
                            {connectionData ?
                            <>
                            <div className="kt-widget__stat">
                                <span className="kt-widget__value"><CurrencySymbol></CurrencySymbol>{connectionData.budget}</span>
                                <span className="kt-widget__caption">Budget</span>
                            </div>
                            <div className="kt-widget__stat">
                                <span className="kt-widget__value"><CurrencySymbol></CurrencySymbol>{connectionData.amountSpent.toFixed(2)}</span>
                                <span className="kt-widget__caption">Spent</span>
                            </div>
                            </> : <></> }</div></div></div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-profile__nav flex-apart">
                
                <ul className="nav nav-tabs nav-tabs-line" role="tablist">
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.activeTab === "giftlist" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("giftlist", e)} role="tab">
                        <i className="flaticon2-gift-1"></i>Giftlist</a>
                    </li>
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.activeTab === "editgiftlist" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("editgiftlist", e)} role="tab">
                            <i className="flaticon2-calendar-3"></i>Edit</a>
                    </li>
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.activeTab === "giftideas" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("giftideas", e)} role="tab">
                        <i className="la la-heart-o"></i>Gift Ideas</a>
                    </li>
                    {activeGiftlist.archive && activeGiftlist.archive.length > 0 ?
                    <li className="nav-item hover-cursor">
                        <a href="#!" className={`nav-link ${ui.activeTab === "archive" ? "active" : ""}`} data-toggle="tab" onClick={(e) => tabClick("archive", e)} role="tab">
                            <i className="flaticon2-box-1"></i>Archive</a>
                    </li> : <></> }
                </ul>
            </div>
        </div>: <></>
        );
  
}

export default UserProfile;
